import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import { Box, Button, CircularProgress } from "@mui/material";
import { isValidInput } from "../../utils/validations";
import { Tasks, Wallet, WalletData } from "../../types/General";
import useTranslation from "../../hooks/traslation";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { SKILLS } from "../../utils/enums";
import MainContainer from "../../layout/MainContainer";
import usePermission from "../../hooks/usePermission";
import moment from "moment";
import WalletList from "../../features/manageWallet/WalletList";
import { useLazyGetWalletListQuery } from "../../services/wallet";
import { showError } from "../../constants/toasts";

function ManageWallet() {
  const { isAdd, isDelete } = usePermission({
    label: "Manage Wallet",
    page_permission: "isView",
  });
  const [getWallet] = useLazyGetWalletListQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const translation = useTranslation();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<Wallet[]>([]);
  const limit = 10;

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const navigate = useNavigate();

  const getAllPayment: any = async () => {
    setLoading(true);
    try {
      const response = await getWallet({
        page,
        limit,
        search: debouncedSearchTerm.trim(),
        status: 1,
      }).unwrap();

      if (response?.statusCode === 200) {
        setLoading(false);
        setRows(response?.data[0]?.list || []);
        setCount(response?.data[0]?.totalCount);
      } else {
        setLoading(false);
        setRows([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    getAllPayment();
  }, [page, debouncedSearchTerm]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Wallet</h1>
        <div className="cards">
          <Box className="search_box" style={{ marginBottom: "20px" }}>
            <SearchBar
              placeholder={translation.user.SearchHere}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "2rem",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <WalletList
                rows={rows}
                isLoading={loading}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                onRefresh={getAllPayment}
              />
              {rows.length !== 0 && (
                <div className="table_footer">
                  <div className="pagination_info">
                    <span className="total_records">Showing {rows.length} of {count} records</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </MainContainer>
    // </CustomTabPanel>
  );
}

export default ManageWallet;
